import Vue from 'vue'

export const toastState = Vue.observable({ list: [] })

let seq = 0

export function toast (text, type = 'info', duration = 2800) {
  const id = ++seq
  toastState.list.push({ id, text, type })
  setTimeout(() => {
    toastState.list = toastState.list.filter(t => t.id !== id)
  }, duration)
}

toast.success = text => toast(text, 'success')
toast.error = text => toast(text, 'error', 3600)
